var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import React, { useMemo } from 'react';
import { useTrackEvent } from '../../hooks';
export var TrackedCallback = function (_a) {
    var children = _a.children, eventType = _a.eventType, eventName = _a.eventName, eventProperties = _a.eventProperties, transformEventProperties = _a.transformEventProperties, callback = _a.callback;
    var trackEvent = useTrackEvent();
    var pageFormat = location.pathname;
    var pageArr = pageFormat.split('/');
    if (process.env.REACT_APP_LOCAL_CG_ENV) {
        // ['', 'client', '4643ed27-ec5f-4a3c-a3aa-3f39a79d032d', 'assessments']
        pageArr[2] = '[:id]';
    }
    else {
        // ['admin', 'compass', 'client', 'a6ac7f54-1179-4e49-a7df-40e316fe759f', 'assessments']
        pageArr[4] = '[:id]';
    }
    pageFormat = pageArr.join('/');
    var generateCallback = function (onChildCallback) {
        return function (args) {
            var transformedEventProperties = transformEventProperties
                ? __assign(__assign({}, eventProperties), transformEventProperties(args)) : eventProperties;
            trackEvent(eventType, pageFormat, eventName, transformedEventProperties);
            if (onChildCallback) {
                return onChildCallback(args);
            }
        };
    };
    var trackedComponent = useMemo(function () {
        return React.Children.map(children, function (child) {
            if (!child) {
                return;
            }
            var newProps = __assign({}, child.props);
            newProps[callback] = generateCallback(newProps[callback]);
            return React.cloneElement(child, newProps, child.props.children);
        });
    }, [children]);
    return _jsx(_Fragment, { children: trackedComponent });
};
